import { AxiosReportLas, AxiosGlobalFilters } from '../config';
import qs from 'qs';
import { applyArrayFilter } from 'utils/applyArrayFilter';

const QRcodeService = {
  getQRcode: objs => {
    const { empresa, tipoEquipamento, unidades, grupoArea } = objs;
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Listagem/ListagemEquipamentos',
      data: {
        empresa,
        tipoEquipamento,
        unidades,
        grupoArea,
      },
      headers: {
        'content-type': 'application/json',
      },
    });
  },

  getQRCodeEquipamentosAtivos: ({
    pageSize = 1000,
    pageIndex = 1,
    empresaId,
    siteId,
    fornecedoresIds,
    sistemaId,
    tipoEquipamentoId,
    grupoAreaId,
    subGrupoAreaIds,
    equipamentoIds,
    areaId,
    grupoEquipamentoId,
    planoAtividadeId,
  }) => {
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };
    const headers = {
      EmpresaId: empresaId,
    };

    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');
    if (sistemaId) params.SistemaId = sistemaId;
    if (tipoEquipamentoId) params.TipoEquipamentoId = tipoEquipamentoId;
    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaIds, 'SubGrupoAreaId');
    applyArrayFilter(params, equipamentoIds, 'EquipamentoId');
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, grupoEquipamentoId, 'GrupoEquipamentoId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadeId');

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/equipamentos/ativos',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getQRCodeAreasAtivas: ({
    empresaId,
    siteId,
    fornecedoresIds,
    grupoAreaId,
    subGrupoAreaId,
    search,
    pageIndex = 1,
    pageSize = 1000,
    usuarioId,
    areaId,
    planoAtividadeId,
  }) => {
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };
    const headers = {
      empresaId: empresaId,
    };
    applyArrayFilter(params, siteId, 'SiteId');
    applyArrayFilter(params, fornecedoresIds, 'FornecedoresIds');
    applyArrayFilter(params, grupoAreaId, 'GrupoAreaId');
    applyArrayFilter(params, subGrupoAreaId, 'SubGrupoAreaId');
    if (search) params.Search = search;
    if (usuarioId) params.UsuarioId = usuarioId;
    applyArrayFilter(params, areaId, 'AreaId');
    applyArrayFilter(params, planoAtividadeId, 'PlanoAtividadeId');
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/areas/ativas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getQRCodeUnidadesAtivas: ({
    empresaId,
    unidadeId,
    usuarioTipo,
    usuarioId,
    grupoUnidadeIds,
    subGrupoUnidadeIds,
    estadoId,
    cidadeId,
    codigo,
    grupoUnidadeId,
    subGrupoUnidadeId,
    pageSize = 1000,
    pageIndex = 1,
  }) => {
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };

    if (usuarioTipo) params.UsuarioTipo = usuarioTipo;
    if (usuarioId) params.UsuarioId = usuarioId;
    applyArrayFilter(params, grupoUnidadeIds, 'GrupoUnidadeIds');
    applyArrayFilter(params, subGrupoUnidadeIds, 'SubGrupoUnidadeIds');
    if (estadoId) params.EstadoId = estadoId;
    if (cidadeId) params.CidadeId = cidadeId;
    if (codigo) params.Codigo = codigo;
    if (grupoUnidadeId) params.GrupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId) params.SubGrupoUnidadeId = subGrupoUnidadeId;
    if (grupoUnidadeId) params.grupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId) params.subGrupoUnidadeId = subGrupoUnidadeId;

    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/unidades/ativas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },
};

export { QRcodeService };
